/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Countdown_StartInputs */

const en_us2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the countdown`)
};

const pt_br2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar a contagem`)
};

const es_419_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar la cuenta regresiva`)
};

const pt_pt2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar a contagem`)
};

const fr_fr2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer le compte à rebours`)
};

const de_de2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown starten`)
};

const it_it2_body_assessment_countdown_start = /** @type {(inputs: Body_Assessment_Countdown_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia il conto alla rovescia`)
};

/**
* | output |
* | --- |
* | "Start the countdown" |
*
* @param {Body_Assessment_Countdown_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_countdown_start = /** @type {((inputs?: Body_Assessment_Countdown_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Countdown_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_countdown_start(inputs)
	if (locale === "es-419") return es_419_body_assessment_countdown_start(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_countdown_start(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_countdown_start(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_countdown_start(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_countdown_start(inputs)
	return en_us2_body_assessment_countdown_start(inputs)
});
export { body_assessment_countdown_start as "body-assessment.countdown_start" }